<template>
  <div>
    <v-flex md12 ma-0 pa-0 d-flex>
      <Card class="mt-1 mb-2 mr-1 ml-1" v-for="item in status" :key="item.name">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3 pt-2>
            <img
              :src="require(`../../../assets/${item.icon}`)"
              alt="battery"
              height="35px"
              width="35px"
            />
          </v-flex>
          <v-flex md9 pa-1>
            <div class="subheading text-xs-center">{{ $t(item.name) }}</div>
            <div
              :class="
                item.value == 'No Data'
                  ? 'body-1 text-xs-center error--text'
                  : 'body-1 text-xs-center number--text'
              "
            >
              {{ item.value == "No Data" ? $t("No Data") : item.value }}
            </div>
          </v-flex>
        </v-layout>
      </Card>
    </v-flex>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PlantOverview from "@/services/PlantOverview";
import { mapGettersMixin } from "@/util/mixin/index";
const momentTz = require('moment-timezone');

export default {
  mixins: [mapGettersMixin],
  data() {
    return {
      status: [],
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getActivePlantTimezone"]),
  },
  mounted() {
    this.setIntervalWithoutDelay(this.getStatusData, 60000);
  },
  methods: {
    getStatusData() {
      const tz = this.getActivePlantTimezone;
      PlantOverview.getWidgetPlant(
        this.getSelectedPlantId,
        momentTz().tz(tz).format("X"),
        momentTz().tz(tz).format("X")
      ).then((res) => {
        const timeResult = res.data.message.filter((el) => el.name === "Time");
        let InsResult = res.data.message.filter(
          (el) => el.name === "Instant Grid Availability"
        );
        InsResult[0]["name"] = "Grid Status";
        InsResult[0]["icon"] = "monitoring.png";
        const value = _.cloneDeep(InsResult[0])["value"];
        if (value == null || value == undefined) {
          InsResult[0]["value"] = "No Data";
          InsResult[0]["textColor"] = "grey--text";
        } else {
          InsResult[0]["value"] = value ? "UP" : "DOWN";
          InsResult[0]["textColor"] = value ? "green--text" : "error--text";
        }
        let newArr = Object.keys(timeResult[0].value).map((name) => {
          const obj = {};
          obj["name"] = name.startsWith("start") ? "Inv Start" : "Inv Stop";
          obj["icon"] = name.startsWith("start")
            ? "start-watch.png"
            : "stop-watch.png";
          obj["value"] =
            timeResult[0].value[name] == "-"
              ? "--:--"
              : timeResult[0].value[name];
          obj["textColor"] = "grey--text";
          return obj;
        });

        this.status = [...newArr, ...InsResult];
      });
    },
  },
  watch: {
    getSelectedPlantId() {
      this.setIntervalWithoutDelay(this.getStatusData, 60000);
    },
  },
};
</script>
